import Vue from 'vue'

Vue.filter('pmlNl2br', function (value) {
    var breakTag = '<br />'
    return (value + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
})



// WEBPACK FOOTER //
// ./src/utils/filters/nl2br.js